
export enum ActivityType {
	ClockIn = 0,
	ClockOut = 1,
	Meal = 2,
	Rest = 3,
	NotableActivity = 4,
	FlexDoc = 5
}